import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "dialog"];
  connect() {
    console.debug("PreviewImageDialog connected");
    this.modal = bootstrap.Modal.getOrCreateInstance(this.dialogTarget, {
      backdrop: 'true'
    });
  }

  disconnect() {
    console.debug("PreviewImageDialog disconnected");
  }

  open(e) {
    if (!this.modal.isOpened) {
      this.modal.show();
    }
  }

  hide() {
    this.modal.hide();
  }

  close(event) {
    if (event.detail.success) {
      this.modal.hide();
    }
  }

  showImage(event) {
    console.debug(event, this.dialogTarget);
    this.imageTarget.src = event.target.src;
    this.open();
  }
}
